import { render, staticRenderFns } from "./UserRentalRecord.vue?vue&type=template&id=0771c884&"
import script from "./UserRentalRecord.vue?vue&type=script&lang=js&"
export * from "./UserRentalRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports